import wixLocation from 'wix-location';
import wixAnimations from 'wix-animations';
import { getHomeCustomPosts, getHomeMainPosts } from 'backend/DBFunctions.jsw';
import { responsifySection, linkText } from 'public/helpers.js';
import { siteCategories, categoryPath } from 'public/categories.js';
import wixWindow from 'wix-window';

let formFactor = wixWindow.formFactor;

let baseUrl = '';
//do not remove async onReady for SEO matters!
$w.onReady(function () {
    setResponsive()
    return initPage();
});

function initPage() {
    baseUrl = wixLocation.baseUrl;
    $w('#mainFeaturedPostDataset').onReady(() => {
        const post = $w('#mainFeaturedPostDataset').getCurrentItem()
        setPostData('mainPost', post);
    });

    $w('#secFeaturedPostDataset').onReady(() => {
        const post = $w('#secFeaturedPostDataset').getCurrentItem()
        setPostData('secPost', post);
    });
    responsifyPage();

    return Promise.all([
        setHomeMainPosts(),
        setCustomSections(),
    ])
}

function responsifyPage() {
    if (formFactor !== "Mobile") {
        // responsifySection($w("#boxMostMainBig1"));
        // responsifySection($w("#boxMostMainBig4"));
        // responsifySection($w("#boxNewTrendingBig1"));
        // responsifySection($w("#boxWebDesignBig1"));
        // responsifySection($w("#boxBrandingBig1"));
    }
}
async function setHomeMainPosts() {
    const mainPosts = await getHomeMainPosts();
    /// reorder main posts ///
    console.log(mainPosts)
    let newMainPosts = []
    newMainPosts.push(mainPosts[5])
    newMainPosts.push(mainPosts[0])
    newMainPosts.push(mainPosts[4])
    newMainPosts.push(mainPosts[2])
    newMainPosts.push(mainPosts[3])
    newMainPosts.push(mainPosts[1])
    /// reorder main posts ///

    newMainPosts.forEach((post, index) => {
        // let mainCategory = siteCategories[item.post.categories[0]];
        // item.post.mainCategory = mainCategory;
        assignPostDataToUI(`post${index+1}`, post);
    });
}

function assignPostDataToUI(type, post) {
    const {
        postPageUrl = '',
            title,
            coverImage = '',
            categories = [],
            relatedPosts = []
    } = post || {};

    $w(`#${type}Title`).text = title;
    linkText($w(`#${type}Title`), baseUrl + postPageUrl)
    if (formFactor === 'Mobile') {
        $w(`#${type}Image`).src = coverImage;
        $w(`#${type}ImageBox`).onClick(() => {
            wixLocation.to(postPageUrl);
        })
        $w(`#${type}Image`).alt = title
    } else {
        $w(`#${type}Column`).background.src = coverImage;
        $w(`#${type}Column`).background.alt = title;
        $w(`#${type}Column`).onClick(() => {
            wixLocation.to(postPageUrl);
        });
        $w(`#${type}Column`).onMouseIn(() => {
            runHoverEffect($w(`#${type}Column`), 0.8)
            resetStyles(type, 'opacity')
        });
        $w(`#${type}Column`).onMouseOut(() => {
            runHoverEffect($w(`#${type}Column`), 1)
            resetStyles(type, 'opacity')
        });
        $w(`#${type}Category`).onMouseIn(() => {
            changeTextColor($w(`#${type}Category`), '#166AEA')
            resetStyles(type, 'color')
        })
        $w(`#${type}Category`).onMouseOut(() => {
            const color = '#000000';
            changeTextColor($w(`#${type}Category`), color)
            resetStyles(type, 'color')
        })
        $w(`#${type}Title`).onMouseIn(() => {
            underlineText($w(`#${type}Title`), true)
            resetStyles(type, 'underline')
        });
        $w(`#${type}Title`).onMouseOut(() => {
            underlineText($w(`#${type}Title`), false)
            resetStyles(type, 'underline')
        });
    }
    const { label: categoryLabel = '', categoryPageUrl = '' } = siteCategories[categories[0]._id] || {};
    $w(`#${type}Category`).text = categoryLabel.toUpperCase();
    let fullCategoryPageUrl = baseUrl + categoryPath.concat(categoryPageUrl.split('/')[2]);
    let fullCategoryPageUrlFinal = fullCategoryPageUrl.replace(/category/g, "categories");
    linkText($w(`#${type}Category`), fullCategoryPageUrlFinal)
    $w(`#${type}Category`).show();
}

async function setCustomSections() {
    const websiteEssentialsTitle = $w('#websiteEssentialsTitle').text;
    const businessStrategiesTitle = $w('#businessStrategiesTitle').text;
    const editorsPickTitle = $w('#editorsPickTitle').text;
    const customPostsArr = await Promise.all(
        [
            getHomeCustomPosts(editorsPickTitle, 3),
            getHomeCustomPosts(websiteEssentialsTitle, 3),
            getHomeCustomPosts(businessStrategiesTitle, 3)
        ]
    )
    setCustomSectionPosts($w('#editorsPicksColumns'), $w('#editorsPickData'), customPostsArr[0]);
    setCustomSectionPosts($w('#websiteEssentialsColumns'), $w('#websiteEssentialsData'), customPostsArr[1]);
    setCustomSectionPosts($w('#businessStrategiesColumns'), $w('#businessStrategiesData'), customPostsArr[2]);
    return
}

function setPostData(type, post) {
    const isPostSec = type.includes('sec');
    const {
        postPageUrl = '',
            coverImage = '',
            categories = [],
            title = '',
            relatedPosts = []
    } = post || {};

    const category = categories[0] && siteCategories[categories[0]];
    const { label: categoryLabel = '', categoryPageUrl = '' } = category || {};
    $w(`#${type}Category`).text = categoryLabel.toUpperCase();
    const siteRevision = wixLocation.query['siteRevision'];
    let fullCategoryPageUrl = `${baseUrl}${categoryPath.concat(categoryPageUrl.split('/')[2])}`;
        let fullCategoryPageUrlFinal = fullCategoryPageUrl.replace(/category/g, "categories");
    linkText($w(`#${type}Category`), fullCategoryPageUrlFinal)
    $w(`#${type}Category`).show();
    linkText($w(`#${type}Title`), baseUrl + postPageUrl)
    if (['mainPost', 'secPost'].includes(type)) {
        linkText($w(`#${type}Description`), baseUrl + postPageUrl)
    }
    $w(`#${type}Column`).background.alt = title;
    $w(`#${type}Column`).onClick(() => {
        wixLocation.to(postPageUrl);
    });
    $w(`#${type}Column`).onMouseIn(() => {
        runHoverEffect($w(`#${type}Column`), 0.8)
        resetStyles(type, 'opacity')
    });
    $w(`#${type}Column`).onMouseOut(() => {
        runHoverEffect($w(`#${type}Column`), 1)
        resetStyles(type, 'opacity')
    });
    $w(`#${type}Category`).onMouseIn(() => {
        changeTextColor($w(`#${type}Category`), '#166AEA', isPostSec)
        resetStyles(type, 'color')
    })
    $w(`#${type}Category`).onMouseOut(() => {
        const color = isPostSec ? '#ffffff' : '#000000';
        changeTextColor($w(`#${type}Category`), color, isPostSec)
        resetStyles(type, 'color')
    })
    $w(`#${type}Title`).onMouseIn(() => {
        underlineText($w(`#${type}Title`), true)
        resetStyles(type, 'underline')
    });
    $w(`#${type}Title`).onMouseOut(() => {
        underlineText($w(`#${type}Title`), false)
        resetStyles(type, 'underline')
    });

}

function setCustomSectionPosts(postsColumnsContainers, postsDataContainers, customPosts) {
    let postsImages = postsColumnsContainers && postsColumnsContainers.children;
    let postsDataTexts = postsDataContainers.children.map(child => child.children[0]);
    let postsBoxes;
    if (formFactor === 'Mobile') {
        postsImages = postsDataContainers.children.map(child => child.children[0].children[0]);
        postsBoxes = postsDataContainers.children.map(child => child.children[0]);
        postsDataTexts = postsDataContainers.children.map(child => child.children[1]);
    }
    customPosts.forEach((post, index) => {
        const { title = '', postPageUrl = '', mainCategory: { label = '', categoryPageUrl = '' } = {}, coverImage = '', relatedPosts = [] } = post || {};

        if (formFactor === 'Mobile') {
            postsImages[index].src = coverImage;
            postsBoxes[index].onClick(() => {
                wixLocation.to(postPageUrl);
            });
            postsImages[index].alt = title
        } else {
            postsImages[index].background.src = coverImage;
            postsImages[index].background.alt = title;
            postsImages[index].onClick(() => {
                wixLocation.to(postPageUrl);
            })
            postsImages[index].onMouseIn(() => {
                runHoverEffect(postsImages[index], 0.8)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'opacity')
            }).onMouseOut(() => {
                runHoverEffect(postsImages[index], 1)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'opacity')
            })
            // postsDataTexts[index].onMouseIn(() => {
            //     changeTextColor(postsDataTexts[index][0], '#166AEA')
            //     resetCustomSectionStyle(postsDataTexts, postsImages, index, 'color')
            // })
            // postsDataTexts[index].onMouseOut(() => {
            //     changeTextColor(postsDataTexts[index][0], '#000000')
            //     resetCustomSectionStyle(postsDataTexts, postsImages, index, 'color')
            // })
            postsDataTexts[index].onMouseIn(() => {
                underlineText(postsDataTexts[index], true)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'underline')
            });
            postsDataTexts[index].onMouseOut(() => {
                underlineText(postsDataTexts[index], false)
                resetCustomSectionStyle(postsDataTexts, postsImages, index, 'underline')
            });
        }
        // postsDataTexts[index][0].text = label.toUpperCase();
        postsDataTexts[index].text = title;
        // postsDataTexts[index][0] && postsDataTexts[index][0].onClick(() => {
        //     wixLocation.to(categoryPath.concat(categoryPageUrl.split('/')[2]));
        // });
        linkText(postsDataTexts[index], baseUrl + postPageUrl)
    })
    formFactor !== 'Mobile' && postsColumnsContainers.show();
    postsDataContainers.show();

}

function runHoverEffect(element, opacity) {
    let timeLine = wixAnimations.timeline();
    timeLine.add(element, {
            // "y": upPixels,
            "opacity": opacity,
            "duration": 150,
            "easing": "easeInOutCubic"
        })
        .play();
}

function changeTextColor(element, color, sec = false) {
    let textHtml = element.html;
    const defaultColor = '#000000';
    const hoverColor = '#166AEA'
    const index = textHtml.lastIndexOf('style="')
    const colorIndex = textHtml.substring(index).indexOf('color');
    let newHtml;
    switch (true) {
    case colorIndex < 0:
        newHtml = textHtml.slice(0, index + 7) + `color:${color};` + textHtml.slice(index + 7);
        break;
    case color !== hoverColor:
        if (sec) {
            newHtml = textHtml.replace(/color:#166AEA;/g, `color:#ffffff;`);
            break;
        }
        newHtml = textHtml.replace(/color:#166AEA;/g, `color:#000000;`);
        break;
    default:
        if (sec) {
            newHtml = textHtml.replace(/color:#ffffff;/g, `color:#166AEA;`);
            break;
        }
        newHtml = textHtml.replace(/color:#000000;/g, `color:#166AEA;`);
        break;

    }
    element.html = newHtml;
}

function resetStyles(currentElement, styleType) {
    const posts = ['post1', 'post2', 'post3', 'post4', 'post5', 'post6', 'mainPost', 'secPost'];
    const index = posts.indexOf(currentElement);
    if (index > -1) {
        posts.splice(index, 1);
    }
    const isPostSec = currentElement === 'secPost' ? true : false;
    const color = isPostSec ? '#ffffff' : '#000000';

    switch (styleType) {
    case 'color':
        underlineText($w(`#${currentElement}Title`), false);
        runHoverEffect($w(`#${currentElement}Column`), 1);
        break;
    case 'underline':
        runHoverEffect($w(`#${currentElement}Column`), 1);
        changeTextColor($w(`#${currentElement}Category`), color, isPostSec);
        break;
    case 'opacity':
        changeTextColor($w(`#${currentElement}Category`), color, isPostSec);
        underlineText($w(`#${currentElement}Title`), false)
        break;
    default:
        break;
    }
    posts.forEach(post => {
        const isPostSec = post === 'secPost' ? true : false;
        const color = isPostSec ? '#ffffff' : '#000000';
        changeTextColor($w(`#${post}Category`), color, isPostSec);
        underlineText($w(`#${post}Title`), false);
        runHoverEffect($w(`#${post}Column`), 1);
    })
}

function resetCustomSectionStyle(postsData, postsImages, currentIndex, style) {
    for (let i = 0; i < postsImages.length; i++) {
        if (i === currentIndex) {
            switch (style) {
            case 'color':
                underlineText(postsData[i], false);
                runHoverEffect(postsImages[i], 1);
                break;
            case 'underline':
                runHoverEffect(postsImages[i], 1);
                // changeTextColor(postsData[i][0], '#000000');
                break;
            case 'opacity':
                // changeTextColor(postsData[i][0], '#000000');
                underlineText(postsData[i], false);
                break;
            }
        } else {
            // changeTextColor(postsData[i][0], '#000000')
            underlineText(postsData[i], false)
        }
    }
}

function underlineText(text, style) {
    // text - decoration - line
    let textHtml = text.html;
    const index = textHtml.lastIndexOf('style="')
    const colorIndex = textHtml.substring(index).indexOf('text-decoration');
    let newHtml;
    if (colorIndex < 0 && style) {
        newHtml = textHtml.slice(0, index + 7) + `text-decoration-line:underline;` + textHtml.slice(index + 7);
    } else {
        if (style) {
            newHtml = textHtml.replace(/text-decoration-line:none;/g, `text-decoration-line:underline;`);
        } else {
            newHtml = textHtml.replace(/text-decoration-line:underline;/g, `text-decoration-line:none;`);
        }
    }
    text.html = newHtml;

}

// Responsive Text Function - Do Not Edit

function setResponsive() {
    if (wixWindow.formFactor === "Desktop") {
        let fontSizeTitle = 2.5
        makeResponsive("#mainPostTitle", "h1", fontSizeTitle, "#000", 1.1, null, 30, "left");
        makeResponsive("#secPostTitle", "h2", fontSizeTitle, "#fff", 1.1, null, null, "center");
        let fontSizeTitleH3 = 1.5
        let widthH3 = 27
        makeResponsive("#post1Title", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#post2Title", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#post3Title", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#post4Title", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#post5Title", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#post6Title", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");

        makeResponsive("#text55", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text53", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text51", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text23", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text20", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text21", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text46", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text44", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");
        makeResponsive("#text42", "h3", fontSizeTitleH3, "#000", 1.3, null, widthH3, "left");

    }
}

function makeResponsive(elementId, textTheme, fontSize, fontColor, lineHeight, charSpacing, width, textAlign) {
    let style = "font-size:" + fontSize + "vw;color:" + fontColor + ";line-height:" + lineHeight + ";letter-spacing:" + charSpacing + "vw;width:" + width + "vw" + ";text-align:" + textAlign;
    $w(elementId).html = "<" + textTheme + " style=" + style + ">" + $w(elementId).text + "</" + textTheme + ">"
}